// extracted by mini-css-extract-plugin
module.exports = {"section":"Section_section__XFSK8","first":"Section_first__bRq9P","last":"Section_last__F9qI8","noMargin":"Section_noMargin__tC8oR"};